import './productlist.scss'
import { Product } from '../../interface/interfaces'
import { AnimatePresence, motion } from 'framer-motion';
import ProductsSkeleton from '../SkeletonLoaders/ProductsSkeleton';
import { ShoppingCartIcon } from 'lucide-react';
import ProductCard from '../ProductCard/ProductCard';


type Props = {
  products: Product[],
  isLoading: boolean,
  setProducts: React.Dispatch<React.SetStateAction<Product[]>>
}



const ProductList = ({ products, isLoading,setProducts }: Props) => {

  const setProduct = (product_data: Product) => {
        // Put new product data in products
        setProducts((prev) => {
            let arr = [...prev]

            let newArr = arr.map((data) => {
                return data.productId === product_data.productId ? product_data : data
            })

            return newArr
        })

    }

 

  return (
    <div className='productlist'>

      {/* <div className='rez'> */}


        <AnimatePresence mode="wait">
          {isLoading && (
            <motion.div initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
              exit={{ opacity: 0 }}>
              <ProductsSkeleton number={8}></ProductsSkeleton>
            </motion.div>
          )}

          {!isLoading && (
            <>
              <motion.div className='productsCont' initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                exit={{ opacity: 0 }}>

                {products.map((data, index) => (

                  <ProductCard data={data} index={index} setProduct={setProduct}></ProductCard>

                ))}

              </motion.div>

              {products.length < 1 && (
                <div className='emptycart'>
                  <div className='idiv'>
                    <ShoppingCartIcon size={70} strokeWidth={1.5} className='bigcart'></ShoppingCartIcon>
                    <div className='text'>No products found</div>
                  </div>
                </div>
              )}
            </>

          )}
        </AnimatePresence>

      {/* </div> */}



    </div>

  )

}


export default ProductList